import SettingsExpertTeamDetailsEditModalComponent from './team-details-edit-modal.component'

const SettingsExpertTeamDetailsEditModalModule = angular.module('cdbl.team-details-edit-modal', [

])
  .component('cdblSettingsExpertTeamDetailsEditModal', SettingsExpertTeamDetailsEditModalComponent)
  .name

export default SettingsExpertTeamDetailsEditModalModule
